import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {OrganizationComponent} from '@components/administration/organization/organization.component';
import {ConfigurationComponent} from '@components/administration/organization/configuration/configuration.component';
import {USER_ROLE} from '@constants/user-role.constant';
import {AuthorizationGuardService} from 'src/app/shared/authorization-guard/authorization-guard.service';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {
    path: 'organizations', component: OrganizationComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  },
  {
    path: 'organizations/:details', component: ConfigurationComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class OrganizationRoutingModule {
}
